import useApi from "../useApi";

const useOptionStandService = (type) => {

  const {api} = useApi()

  const index = (callbackSuccess, callbackValidationErrors) => {
    return api(
      'get',
      'options/' + type,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useOptionStandService::index: ${error?.message || JSON.stringify(error)}`)},
    )
  }

  const create = (callbackSuccess, callbackValidationErrors, data) => {
    return api(
      'post',
      'options/' + type + '/create',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {throw new Error(`Error in useOptionStandService::create: ${error?.message || JSON.stringify(error)}`)},
      data
    )
  }

  return {
    index,
    create,
  }
}

export default useOptionStandService
